module.exports = __webpack_public_path__ + "img/icon1.0ee0bbbf.png";